import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, table, Table,Modal, ModalHeader, ModalBody, ModalFooter  } from "reactstrap";
import {
  postMethod,
  validateMobile,
  singleParam,
  editUserGrid,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import TextField from "@material-ui/core/TextField";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { WEB_BASE_URL } from "../../../../_services/constant";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddSession = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const websitelink = "https://admin.quicktagg.com/";
  const [copylink, setCopylink] = useState("");
   const [customerSessionID, setCustomerSessionID] = useState("");
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);  
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [loadSeachProduct, setLoadSeachProduct] = useState(false);
  const [loadSendSMS, setLoadSendSMS] = useState(false);
  const [customerRequired, setCustomerRequired] = useState(false);
  const [copyed, setCopyed] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomers, setselectedCustomers] = useState([]);
  const [productsValidation, setProductsValidation] = useState(false);
  const [subcategory, setSubcategory] = useState([]);
  const [selectedSubCategory, setselectedSubCategory] = useState([]);
  const [productlist, setproductlist] = useState([]);
  const [selectedSubCategoryObject, setSelectedSubCategoryObject] = useState({
    mtran_id: "",
    category_id: "",  
    subcategory_id: "",
    text: "",
    min_amount:null,
    max_amount:null
  });
  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id, 
    entry_no: "", 
    title: "", 
    mobile: "",   
    customer_id: "",
    customer_name: "",   
    customer_session_products: [],
    remarks: "",
    otp_limit: "",
    link_expire_days:"",
    popup_required: "",
  });
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false); 
  const [isvalid, setIsValid] = useState({
    mobile: false,
    email: true,
  });
  const [valid, setValid] = useState({
    mobile: true,
    email: true,
  });

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        marginLeft: -10,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 310,
      },
    },
  };

  const addData = (values) => {
    if(param.customer_id == "")
    {
      setCustomerRequired(true);
    }
     else if(selectedSubCategory.length == 0)
    {
     setProductsValidation(true);
    }
    else{
         setLoadInsert(true); 
    param.customer_session_products =selectedSubCategory;
    postMethod("api/transactions/customer/session/insert", param).then((dataD) => {
      var data = dataD.data[0];
      console.log(data)
      if (data) {
        setLoadInsert(false); 
        setParam({...param,tran_id:data.new_identity});
        setCopylink(WEB_BASE_URL+"c?t="+data.customerID);      
        setCustomerSessionID("c?t="+data.customerID); 
        toggle();
      }
      else{
        setLoadInsert(false); 
      }
    });
  }
  };

  const checkMobile = (val) => {
    setParam({ ...param, mobile: val });
    if (val.length !== 10) {
      setValid({ ...valid, mobile: false });
      setIsValid({...isvalid,mobile:false});
    } else {
      setValid({ ...valid, mobile: true });
      postMethod("api/transactions/customer/session/getCustomer", { mobile: val }).then((dataD) => {
        var data = dataD.data[0];
        if (data) {
          setParam({
            ...param,
            customer_name: data.full_name,
            customer_id: data.customer_id,
            mobile: data.mobile,
          });
           setIsValid({...isvalid,mobile:false});
      }
      else{
          setParam({
            ...param,
            customer_name: "",
            customer_id: "",
            mobile: val,
          });

          setIsValid({...isvalid,mobile:true});
      }

      
      });
    }
  };

  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
        setLoadDelete(true);
      postMethod("api/transactions/customer/session/delete", { tran_id: param.tran_id }).then(
        (data) => {
          if (data.data[0].valid) {
           setSuccessDelete(true);
            setTimeout(() => {
              props.history.push("/branch/customer/session");
            }, 2000);
          }
          else
          {
          setSuccessDelete(true);
              setTimeout(() => {
               setSuccessDelete(false);
            }, 4000);
             setLoadDeleteMsg(data.error)
           setLoadDelete(false);
        }
        }
      );
    }
  };

  useEffect(() => {
    var selectCategory=[];
    postMethod("api/transactions/customer/session/getSubcategory", {branch_id: localStorage.getItem("jwl_branch_id")}).then((data) => {
      setSubcategory(data.data);
      selectCategory =data.data; 
    });
    setLoad(true);
    if (id !== null) {
     
      var temp = window.atob(id);
      postMethod("api/transactions/customer/session/preview", { tran_id: temp }).then((dataD) => {
       var data= dataD.data[0];
       console.log(data);
        setParam({...param,
          tran_id: temp,       
          entry_no: data.entry_no,
          title: data.title,
          otp_limit:data.OTP_limit,
          link_expire_days:data.link_expire_days,
          mobile: data.mobile,
          customer_id: data.customer_id,
          customer_name: data.customer_name,       
          customer_session_products: data.products,
          remarks: data.remarks,
          popup_required: data.popup_required,
          }
          );
          setselectedSubCategory(data.products);     
          let newselectedCategoryArr = [...data.products]
          for (let Mainindex = 0; Mainindex < selectCategory.length; Mainindex++) {
             const elementMain = selectCategory[Mainindex];
            

             for (let logoindex = 0; logoindex < newselectedCategoryArr.length; logoindex++) {
                const element = newselectedCategoryArr[logoindex];                 
                if(element.subcategory_id === elementMain.subcategory_id)
                {
                  selectCategory[Mainindex].checked = 'true';
                }  
             }               
          }  
          setCopylink(WEB_BASE_URL+"c?t="+data.encrypt_id);      
        setSubcategory([...selectCategory]); 
        setCopylink(websitelink+"c?t="+data.encrypt_id)
         setCustomerSessionID("c?t="+data.encrypt_id);
        setLoad(false);
      });
    }
    else{
      postMethod("api/transactions/customer/session/preview", { tran_id: 0 }).then((dataD) => {
        var data =  dataD.data[0];
           setParam({...param,         
             entry_no: data.entry_no
             });   
           setLoad(false);
         });
    }
   
  }, []);
    // check object is null or undefined
    const checkObject = (obj) => {
      return obj === undefined ? {} : Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    // Add  Signle Product into Selected Array
    const AddProduct = (Obj) => {    
       var tempIndex = selectedSubCategory.findIndex(x => x.product_id === Obj.product_id);
       var tempArry = [...selectedSubCategory];
       if(tempIndex > -1){
          tempArry.splice(tempIndex, 1);
          setselectedSubCategory(tempArry);
       }
       else{
            var tempparam = { 
              mtran_id: param.tran_id,
              category_id: Obj.category_id,  
              subcategory_id: Obj.subcategory_id,
              product_id: Obj.product_id,
              product_code: Obj.product_code,
              product_name: Obj.product_name,
              gender: Obj.gender,
              color: Obj.color,
size_length: Obj.size_length,
              price: Obj.price,
               url_image: Obj.url_image,
        image_path: Obj.image_path,
        isImageUrl: Obj.isImageUrl

          }
          tempArry.push(tempparam);
          setselectedSubCategory(tempArry);
       }
    };

      // Add Or Remove ALL Product from arry
     const AddAllProduct = (checkAll) => {   
      var tempArry = [...selectedSubCategory];
      if(checkAll)
      {
      productlist.forEach(Obj => { 
      var tempIndex = tempArry.findIndex(x => x.product_id === Obj.product_id);       
        if(tempIndex == -1){ 
               var tempparam = { 
               mtran_id: param.tran_id,
             category_id: Obj.category_id,  
             subcategory_id: Obj.subcategory_id,
             product_id: Obj.product_id,
             product_code: Obj.product_code,
             product_name: Obj.product_name,
             gender: Obj.gender,
             color: Obj.color,
size_length: Obj.size_length,
             price: Obj.price,
              url_image: Obj.url_image,
            image_path: Obj.image_path,
            isImageUrl: Obj.isImageUrl

          }
          tempArry.push(tempparam);  
        }  
      }); 
      }
      else{
         productlist.forEach(Obj => { 
         var tempIndex = tempArry.findIndex(x => x.product_id === Obj.product_id);       
         if(tempIndex > -1){
          tempArry.splice(tempIndex, 1);    
         }      
      }); 
      }
      
      setselectedSubCategory(tempArry);
    };

    const SearchProduct = () => {
      // alert(selectedSubCategoryObject.category_id + "------" + selectedSubCategoryObject.subcategory_id);
      setLoadSeachProduct(true);
      if (
        selectedSubCategoryObject.subcategory_id !== ""
      ) {
        postMethod("api/transactions/customer/session/getProducts", 
        {
         category_id : selectedSubCategoryObject.category_id,
          subcategory_id: selectedSubCategoryObject.subcategory_id,
          min_amount: selectedSubCategoryObject.min_amount,
          max_amount: selectedSubCategoryObject.max_amount
        }).then((data) => {
          setproductlist(data.data);
        });
      }
        setLoadSeachProduct(false);
    };

    const removeProduct = (i) => {
      let tempArry = [...selectedSubCategory];
      tempArry.splice(i, 1);
      setselectedSubCategory(tempArry);
    };
    const {
      buttonLabel,
      className
    } = props;
  
    const [modal, setModal] = useState(false);
  
    const toggle = () => setModal(!modal); 

     
  // Send SMS To Customers
   const sendSMS = () =>{
    var paramD = {
      tran_id :0,
      mtran_id:param.tran_id,
      sms:"testing",
      type:"customer session",
      customer_id:param.customer_id,
       shared_url:customerSessionID,
       mobile:param.mobile,
       full_name:param.customer_name }
    postMethod("api/transactions/customer/session/SendSms", paramD).then((dataD) => {
       props.history.push("/branch/customer/session");
    });
   }


  return (
    <>
    
<div>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" className={className}  zIndex="999999">
        <ModalHeader toggle={toggle}>Customer Link</ModalHeader>
        <ModalBody>
         <div className="d-flex w-100"> <div style={{background:"rgb(190 196 231)",padding:"16px"}} > 
          {copylink}
          </div> 
          
        <CopyToClipboard text={copylink}
          onCopy={() => {}}>
           {copyed ? <i className="fas fa-copy" style={{color:'#4dd74d',cursor:"pointer",padding:"16px"}}></i> : <i className="fas fa-copy" style={{cursor:"pointer",padding:"16px"}} onClick={()=>{
        setCopyed(true);
         }}></i>} 
        </CopyToClipboard>

            <a href={"http://api.whatsapp.com/send?phone=+91"+param.mobile} message={copylink} style={{padding:"11px"}} target="_blank" ><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="28px" height="28px"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"/></svg></a>
       </div>
        </ModalBody>
        <ModalFooter>
          {loadSendSMS ?   <Button color="info">Sending..</Button>:
          <Button color="primary" onClick={()=> {sendSMS();}}>Send</Button>}      
            {' '}
          <Button color="primary" onClick={()=> {props.history.push("/branch/customer/session")}}>Back to Browse</Button>{' '}
       
        </ModalFooter>
      </Modal>
    </div>


      {load ? <Loader /> : null}
      <Form className="session-editor-form" onSubmit={handleSubmit(addData)}>
        <div className="card card-custom gutter-b session-editor-card">
          <div className="card-header session-editor-header">
            <div className="card-title session-editor-title">
              <span className="session-editor-icon">
                <i className="fa fa-users"></i>
              </span>
              <div>
                <h3 className="card-label">{id ? "Edit Customer Session" : "Add Customer Session"}</h3>
                <p>Create a customer session, choose products, and share the session link.</p>
              </div>
            </div>
          </div>
          <div className="card-body session-editor-body">
            <Row className="session-editor-grid">             
              <Col sm={4}>
                <FormGroup>
                  <Label>Entry No.</Label>
                  <input
                    type="text"
                    required
                    value={param.entry_no}
                    disabled="true"
                    className="form-control h-auto py-2 px-6"
                    name="entry_no"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        entry_no: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Title</Label>
                  <input
                    type="text"
                    required
                    value={param.title}                
                    className="form-control h-auto py-2 px-6"
                    name="title"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        title: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Mobile  {customerRequired ?  <label className="text-danger">*Required</label> : null}</Label>
                  <input
                    type="number"
                    required
                    value={param.mobile}
                    className="form-control h-auto py-2 px-6"
                    name="mobile"
                    onChange={(e) => checkMobile(e.target.value)}
                    ref={register}
                  />
                  {!valid.mobile && (
                    <span className="form-text text-danger">Please enter valid mobile</span>
                  )}
                  {isvalid.mobile && (
                    <span className="form-text text-danger">This Mobile number not registered</span>
                  )}
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>OTP Limit</Label>
                  <input type="number"
                  value={param.otp_limit}
                  onChange={(e) =>{
                    setParam({ ...param, otp_limit: e.target.value })
                  } }
                  className="form-control h-auto py-2 px-6"
                  name="otp_limit"
                  >
                  </input>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Link Expire Days</Label>
                  <input type="number"
                  value={param.link_expire_days}
                  onChange={(e) => setParam({ ...param, link_expire_days: e.target.value })}
                  className="form-control h-auto py-2 px-6"
                  name="link_expire_days"
                  >
                  </input>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Customer Name</Label>
                  <input
                    type="text"
                    required
                    disabled
                    value={param.customer_name}
                    className="form-control h-auto py-2 px-6"
                    name="customer_name"
                    onChange={(e) => setParam({ ...param, customer_name: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              
              <Col sm={8}>
                <FormGroup>
                  <Label>Remarks</Label>
                  <textarea                
                    value={param.remarks}
                    className="form-control h-auto py-2 px-6"
                    name="remarks"
                    onChange={(e) => setParam({ ...param, remarks: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
               
              </Col>
              <Col sm={4}>
                  <FormGroup className="session-editor-check-group">
                    
                    <Label></Label>
                    <input type="Checkbox" checked={ (param.popup_required) ? true : false} className="form-check" name="popup_required" value={param.popup_required} 
                    onChange={(e) => setParam({...param,popup_required: e.target.checked,
                    })} /><text style={{color:'red'}}>Popup Required</text>
                  </FormGroup>
              </Col>
              <Col sm={12}>
                <div className="session-editor-section-title">
                  <h4>Find Products</h4>
                </div>
                <div className="session-editor-table-wrap">
                <Table bordered className="session-editor-table session-editor-search-table">
                  <thead>
                    <tr>                   
                      <th>Name {productsValidation ?  <label className="text-danger">*Required</label> : null}</th>
                      <th>Min Amount</th>
                      <th>Max Amount</th>
                      <th>Action</th>
                    </tr>
                    <tr>
                      <th>
                        <select
                          className="form-control h-auto py-2 px-6"
                          name="product"
                          value={selectedSubCategoryObject.product_id}
                          onChange={(e) =>{
                            setproductlist([]);
                            setSelectedSubCategoryObject({
                              ...selectedSubCategoryObject,
                              category_id: e.target.value.split('-')[0],
                              subcategory_id: e.target.value.split('-')[1],
                              text: e.target.options[e.target.selectedIndex].text,
                            })                           
                          }
                          }
                        >
                          <option value="">-select-</option>
                         {subcategory.length < 0
                            ? null
                            : subcategory.map((obj, i) => {
                                return (
                                  <option key={i} value={obj.category_id+"-"+obj.subcategory_id}>
                                  {obj.subcategory_name + "(" + obj.category_name + ")"}
                                  </option>
                                );
                              })} 
                        </select>
                      </th>
                      <th>
                        <input
                          type="number"
                          className="form-control h-auto py-2 px-6"
                          name="min_amount"
                          onChange={(e) =>
                            setSelectedSubCategoryObject({
                              ...selectedSubCategoryObject,
                              min_amount: e.target.value,
                            })
                          }
                          value={selectedSubCategoryObject.min_amount}
                        />
                      </th>
                      <th>
                        <input
                          type="number"
                          className="form-control h-auto py-2 px-6"
                          name="max_amount"
                          onChange={(e) =>
                            setSelectedSubCategoryObject({
                              ...selectedSubCategoryObject,
                              max_amount: e.target.value,
                            })
                          }
                          value={selectedSubCategoryObject.max_amount}
                        />
                      </th>
                      <th>
                        {loadSeachProduct ?  <button type="button" className="btn btn-primary session-editor-inline-btn">
                          Searching ..
                        </button> : <button type="button" className="btn btn-success session-editor-inline-btn" onClick={() => { SearchProduct()}}>
                          Search
                        </button> }
                       
                      </th>
                    </tr>
                  </thead>                 
                </Table>
                </div>
              </Col>
              

              <Col sm={12}>
                <div className="session-editor-section-title">
                  <h4>Search Results</h4>
                </div>
                <div className="session-editor-table-wrap">
                <Table bordered className="session-editor-table">
                  <thead>
                    <tr>                   
                       <th>Product Code </th>
                       <th>Product Name</th>
                       <th>Gender</th>
                        <th>Color</th>
                         <th>Size</th>
                       <th>Price</th>
                       <th>Qty</th>
                         <th>Image</th>
                        <th>Exhibtion</th>
                       <th>Trial</th>
                      <th  className="d-flex w-100">
                        ALL  <input
                                type="checkbox"                  
                                className="mt-2 ml-2"
                                name="available"
                                 onChange={(e) => {                               
                                     AddAllProduct(e.target.checked)
                                 }}                             
                              />
                                                            </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productlist.length > 0
                      ? productlist.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                ({i + 1}) {obj.product_code}
                              </td>
                              <td>{obj.product_name}</td>
                              <td>{obj.gender}</td>
                               <td>{obj.color}</td>
                              <td>{obj.size_length}</td>
                              <td>{obj.price}</td>
                              <td>{obj.balance_qty ?? '-'}</td>
                              <td>
  {obj.isImageUrl ? (
    <img src={obj.image_path} width="36px" alt="" />
  ) : (
    <img src={obj.url_image + obj.image_path} width="36px" alt="" />
  )}
</td>
                                    <td>{obj.exhibition ? <label className="text-success">Active</label>:<label className="text-danger">Deactive</label>}</td>
                              <td>{obj.trial ? <label className="text-success">Active</label>:<label className="text-danger">Deactive</label>}</td>
                             
                              <td>
                              <input
                                type="checkbox"                  
                                checked={ selectedSubCategory.findIndex(e => e.product_id === obj.product_id) > -1 ? true : false}
                                className="session-editor-row-check"
                                name="available"
                                 onChange={(e) => {                               
                                     AddProduct(obj); 
                                 }}                             
                              />                             
                              </td>
                            </tr>
                          );
                        }) : 
                        <tr>
                          <td colSpan="5" className="text-center">No Data</td>
                        </tr>
                           } 
                  </tbody>
                </Table>
                </div>
              </Col>


  {selectedSubCategory.length > 0 ? 
              <Col sm={12}>
                <div className="session-editor-section-title">
                  <h4>Selected Products</h4>
                </div>
                <div className="session-editor-table-wrap">
                <Table bordered className="session-editor-table">
                  <thead>
                    <tr>                   
                       <th>Product Code </th>
                       <th>Product Name</th>
                       <th>Gender</th>
                       <th>Color</th>
                         <th>Size</th>
                       <th>Price</th>
                       <th>Qty</th>
                       <th>Image</th>
                       <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedSubCategory.length > 0
                      ? selectedSubCategory.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                ({i + 1}) {obj.product_code}
                              </td>
                              <td>{obj.product_name}</td>
                              <td>{obj.gender}</td>
                               <td>{obj.color}</td>
                              <td>{obj.size_length}</td>
                              <td>{obj.price}</td>
                              <td>{obj.balance_qty ?? '-'}</td>
                                 <td>
                              {obj.isImageUrl ? (
  <img src={obj.image_path} width="36px" />
) : (
  <img src={obj.url_image + obj.image_path} width="36px" />
)}

                            </td>
                             <td>
                             
                                <button type="button" className="session-editor-remove-btn" onClick={() => removeProduct(i)}>
                                  <i className="fa fa-times"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        }) : null } 
                  </tbody>
                </Table>
                </div>
              </Col>
: null}

            </Row>




            {success ? <Alert color="success">Saved Successfully</Alert> : null}
           {successDelete ? <Alert color="danger">{loadDeleteMsg}</Alert> : null}
          </div>
          <div className="card-footer text-right session-editor-footer">
              {id && (   
               <button type="button" onClick={toggle} className="btn btn-success mr-2 session-editor-action-btn">
                Session Link
              </button>          
             
            )}
            <a href="/branch/customer/session" className="btn btn-secondary mr-2 session-editor-cancel-btn">
              Cancel
            </a>
          {id && (
              loadDelete ? <button type="button" className="btn btn-danger mr-2 session-editor-action-btn">
                Deleting..
              </button> : 
               <button type="button" onClick={handleDelete} className="btn btn-danger mr-2 session-editor-action-btn">
                Delete
              </button>
            )} 
          
            {loadInser ? 
             <button type="button" className="btn btn-primary session-editor-action-btn">
              Saving..
            </button> :  <button type="submit" className="btn btn-primary session-editor-action-btn">
              Save
            </button>}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddSession;
